import React, { useEffect, useState } from 'react';
import { Button, Col, Table, Row, notification } from 'antd';
import ModalCreateTruck from "../../../../modals/create-truck";
import ModalEditTruck from "../../../../modals/edit-truck";
import Spinner from "../../../../spinner";
import { companyService, systemService } from "../../../../../services";
import ModalShowCarParkInfo from "../../../../modals/show-car-park-info";
import i18n from '../../../../../i18n';

export default function Trucks({ companyId }) {

	const [dataLoaded, setDataLoaded] = useState(false);
	const [loading, setLoading] = useState(false);
	const [isNeedUpdateList, setIsNeedUpdateList] = useState(true);

	const [showModalCreateTruck, setShowModalCreateTruck] = useState(false);
	const [isShowModal, setIsShowModal] = useState(false);

	const [data, setData] = useState([]);
	const [showModalEdit, setShowModalEdit] = useState(false);
	const [carryingCapacityValues, setCarryingCapacityValues] = useState(null);
	const [carryingCapacity, setCarryingCapacity] = useState(null);
	const [showModalEditTruck, setShowModalEditTruck] = useState(false);


	let bigButtonStyle = { width: '190px', height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', float: 'right', borderColor: "#1CAA53" };
	let editButtonStyle = { fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', fontSize: '10px', lineHeight: '12px', color: '#2B3F63', borderRadius: '0px', borderColor: 'transparent', background: "transparent", boxShadow: 'none', padding: "0px" };
	let deleteButtonStyle = { fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', fontSize: '10px', lineHeight: '12px', color: '#EB5757', borderRadius: '0px', borderColor: 'transparent', background: "transparent", boxShadow: 'none' };

	useEffect(() => {
		if (isNeedUpdateList) {
			setIsNeedUpdateList(false);
			setLoading(true);
			companyService.getCompanyTrucks().then((response) => {
				setData(response);
				setLoading(false);
			}).catch((error) => {
				setLoading(false);
				notification.error({
					message: i18n.t('components.notification.titles.getCompanyTrucks'),
					description: error,
				});
			});
		}

		if (!dataLoaded) {
			setDataLoaded(true);
			systemService.getCarryingCapacity()
				.then((response) => {
					setCarryingCapacityValues(response);
				})
				.catch((error) => {
					notification.error({
						message: i18n.t('components.notification.titles.getCarryingCapacity'),
						description: error,
					});
				});
		}
	}, [isNeedUpdateList]);


	const columns = [
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.brand.title'),
			dataIndex: 'brand',
			key: 'brand',
			width: '12%',
			sorter: (a, b) => {
				return a.brand.localeCompare(b.brand);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.carrying.title'),
			dataIndex: 'carrying',
			key: 'carrying',
			width: '11%',
			sorter: (a, b) => {
				return Number(a.carrying) - Number(b.carrying);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.regCountry.title'),
			dataIndex: 'regCountry',
			key: 'regCountry',
			width: '15%',
			sorter: (a, b) => {
				return a.regCountry.localeCompare(b.regCountry);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.number.title'),
			dataIndex: 'number',
			key: 'number',
			width: '12%',
			sorter: (a, b) => {
				return a.number.localeCompare(b.number);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.deliveryCount.title'),
			dataIndex: 'deliveryCount',
			key: 'deliveryCount',
			width: '10%',
			sorter: (a, b) => {
				return Number(a.deliveryCount) - Number(b.deliveryCount);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.mileage.title'),
			dataIndex: 'mileage',
			key: 'mileage',
			width: '12%',
			sorter: (a, b) => {
				return Number(a.mileage) - Number(b.mileage);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.salary.title'),
			dataIndex: 'salary',
			key: 'salary',
			width: '10%',
			sorter: (a, b) => {
				return Number(a.salary) - Number(b.salary);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.questionnaire.title'),
			key: 'questionnaire',

			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							onClick={() => setShowModalEdit(data.id)}
							size="small"
							style={editButtonStyle}>
              {i18n.t('main.buttons.view')}
						</Button>
						<ModalShowCarParkInfo
							isShow={(showModalEdit === data.id)}
							onCloseModal={(isNeedRefresh = false) => {
								setShowModalEdit(false);
								setLoading(isNeedRefresh);
								setIsNeedUpdateList(isNeedRefresh);
							}}
							truckId={data.id}
							info={data}
						/>
					</React.Fragment >
				);
			}
		},
		{
			title: i18n.t('companyPage.carPark.tabs.trucks.table.edit.title'),
			key: 'edit',
			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							onClick={() => setShowModalEditTruck(data.id)}
							size="small"
							style={editButtonStyle}>
							{i18n.t('main.buttons.edit')}
						</Button>
						<ModalEditTruck
							isShow={(showModalEditTruck === data.id)}
							onCloseModal={() => {
								setShowModalEditTruck(null);
								setLoading(true);
								setIsNeedUpdateList(true);
							}}
							truckId={data.id}
						/>
					</React.Fragment >
				);
			}
		},
		/* {
			title: '',
			key: 'delete',
			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							size="small"
							style={deleteButtonStyle}
						>
							{i18n.t('main.buttons.delete')}
						</Button>
					</React.Fragment>
				);
			}
		} */
	];

	return (
		<React.Fragment>
			<Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
				<Row style={{ marginBottom: "25" }}>
					<Col className={"content-header"} style={{ marginBottom: "0px" }} span={12}>{i18n.t('companyPage.carPark.tabs.trucks.title')}</Col>
					<Col span={8} style={{ marginBottom: "0px" }} offset={4}>
						<Button type="primary"
							htmlType="button"
							style={bigButtonStyle}
							onClick={() => {
								setIsShowModal(false);
								setShowModalCreateTruck(true);
							}}>
              {i18n.t('companyPage.carPark.tabs.trucks.buttons.create')}
						</Button>
						<ModalCreateTruck
							companyId={companyId}
							driverId={null}
							isShow={showModalCreateTruck}
							setIsShow={setShowModalCreateTruck}
							setShowAttachDriverOrderDelivery={setIsShowModal}
							carryingCapacityValues={carryingCapacityValues}
							setIsNeedUpdateList={setIsNeedUpdateList}
						/>
					</Col>
				</Row>
				<Col span={24}>
					<Table
						style={{ minWidth: "700px" }}
						columns={columns}
						dataSource={data}
						locale={{ emptyText: i18n.t('main.empty') }}
						rowKey="myid"
						size="small"
						pagination={{
							pageSize: 50,
						}}
						className="car-park"
						rowClassName={(record, index) => ("car-park-row")
						}
					/>
				</Col>
				<Col span={24}>
				</Col>
			</Spinner>
		</React.Fragment >
	);
}
